import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { ITermsConditionsState } from './state';

const state = (state: AppState) => state.termsConditionsState;

export const termsConditions_Form = createSelector(
  state,
  (state: ITermsConditionsState) => state.form
);